import { ClickAwayListener, Divider, Grid, IconButton, MenuItem, MenuList, Paper, Popper, Stack } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { DbMetadataFieldInfos } from "../../../../Core/Api/Types/db-metadata-field-infos";
import { CopyAllOutlined, RemoveCircleOutlineOutlined } from "@mui/icons-material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DoneIcon from "@mui/icons-material/Done";
import TokenBuidler from "./token-builder";
import { TokenizedRuleInfos } from "./commons";
interface SingleRuleLineProps {
  onChange: (e: any, tokenIndex: number, field: string, ruleIndex: number, nrIndex: number) => void;
  metadataFields: DbMetadataFieldInfos[];
  tokenizedNamingRule: TokenizedRuleInfos;
  ruleIndex: number;
  nrIndex: number;
  onDeleteRule: (nrIndex: number, ruleIndex: number) => void;
  onDeleteToken: (nrIndex: number, ruleIndex: number, tokenIndex: number) => void;
  onAddToken: (nrIndex: number, ruleIndex: number, type: "2-conditions" | "condition" | "value") => void;
  onSwapRule: (nrIndex: number, ruleIndex: number, direction: "up" | "down") => void;
  onCopyRule: (nrIndex: number, ruleIndex: number) => void;
  rulesCount: number;
  onCopyToken: (nrIndex: number, ruleIndex: number, tokenIndex: number) => void;
  handleEditRule: (index: number) => void;
}

const SingleRuleLine: React.FC<SingleRuleLineProps> = ({
  onChange,
  metadataFields,
  tokenizedNamingRule,
  ruleIndex,
  nrIndex,
  onDeleteRule,
  onDeleteToken,
  onAddToken,
  onSwapRule,
  rulesCount,
  onCopyRule,
  onCopyToken,
  handleEditRule,
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Divider orientation="horizontal" />
      <Grid container>
        <Grid item md={9.5} sm={8}>
          <Stack spacing={1} direction={"column"}>
            {tokenizedNamingRule.tokens.map((x, i) => (
              <TokenBuidler
                ruleIndex={ruleIndex}
                tokenIndex={i}
                metadataFields={metadataFields}
                onChange={onChange}
                token={x}
                nrIndex={nrIndex}
                onDeleteToken={onDeleteToken}
                onCopyToken={onCopyToken}
                key={i}
              />
            ))}
          </Stack>
        </Grid>
        <Grid display={"flex"} flexDirection={"row-reverse"} alignItems={"center"} item md={2.5} sm={4}>
          <IconButton onClick={(e) => handleEditRule(-1)} size="small">
            <DoneIcon color="success" />
          </IconButton>
          <IconButton size="small" onClick={() => onDeleteRule(nrIndex, ruleIndex)}>
            <RemoveCircleOutlineOutlined color="error" />
          </IconButton>
          <IconButton onClick={() => onCopyRule(nrIndex, ruleIndex)} size="small">
            <CopyAllOutlined color="primary" />
          </IconButton>
          <IconButton
            size="small"
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <AddIcon color="primary" />
          </IconButton>
          {ruleIndex < rulesCount - 1 && (
            <IconButton size="small" onClick={() => onSwapRule(nrIndex, ruleIndex, "down")}>
              <ArrowDownwardIcon color="primary" />
            </IconButton>
          )}
          {ruleIndex > 0 && (
            <IconButton size="small" onClick={() => onSwapRule(nrIndex, ruleIndex, "up")}>
              <ArrowUpwardIcon color="primary" />
            </IconButton>
          )}
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} placement="bottom">
            <Paper sx={{ zIndex: 1299 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={() => onAddToken(nrIndex, ruleIndex, "value")}>value</MenuItem>
                  <MenuItem onClick={() => onAddToken(nrIndex, ruleIndex, "condition")}>condition</MenuItem>
                  <MenuItem onClick={() => onAddToken(nrIndex, ruleIndex, "2-conditions")}>double condition</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Popper>
        </Grid>
      </Grid>
      <Divider orientation="horizontal" />
    </>
  );
};

export default SingleRuleLine;
